import { SET_TEMPLATEADD } from '../actions';

const templateadd = (state = [], action) => {
  switch (action.type) {
	case SET_TEMPLATEADD:
      return [...action.value];  
    default: return state;
  }
}

export default templateadd;
